import getId from "../../../../utils/getId";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import {
  GDANSK_KIND_BASIC_PASS,
  GDANSK_KIND_BEARER_PASS,
  GDANSK_KIND_PASS_OPEN,
  GDANSK_KIND_SINGLE_TICKET,
  GDANSK_KIND_SWIMMING_TRACK,
} from "./gdanskSaleStepsConsts";

export type GdanskSaleFormType =
  | typeof GDANSK_KIND_BASIC_PASS
  | typeof GDANSK_KIND_PASS_OPEN
  | typeof GDANSK_KIND_BEARER_PASS
  | typeof GDANSK_KIND_SINGLE_TICKET
  | typeof GDANSK_KIND_SWIMMING_TRACK;

export const GDANSK_DATE_INPUT = "date";
export const GDANSK_LANE_SELECT_INPUT = "lane-select";
export const GDANSK_ENTRIES_QNT_INPUT = "entries-qnt";
export const GDANSK_BASIN_KIND_INPUT = "basin-kind";
export const GDANSK_TIME_OF_DAY_INPUT = "time-of-day";
export const GDANSK_INSTRUCTOR_CHECKBOX_INPUT = "instructor-checkbox";
export const GDANSK_INSTRUCTOR_LANE_INPUT = "intructor-lane";
export const GDANSK_DATES_INFO = "dates-info";

export type GdanskSaleFormFieldConfig =
  | typeof GDANSK_DATE_INPUT
  | typeof GDANSK_LANE_SELECT_INPUT
  | typeof GDANSK_ENTRIES_QNT_INPUT
  | typeof GDANSK_BASIN_KIND_INPUT
  | typeof GDANSK_TIME_OF_DAY_INPUT
  | typeof GDANSK_INSTRUCTOR_CHECKBOX_INPUT
  | typeof GDANSK_INSTRUCTOR_LANE_INPUT
  | typeof GDANSK_DATES_INFO;

const gdanskSaleFormConfigs: Record<
  GdanskSaleFormType,
  { fields: GdanskSaleFormFieldConfig[]; validate: (form: GdanskSaleForm) => boolean }
> = {
  [GDANSK_KIND_BASIC_PASS]: {
    fields: [GDANSK_DATE_INPUT, GDANSK_LANE_SELECT_INPUT, GDANSK_ENTRIES_QNT_INPUT, GDANSK_DATES_INFO],
    validate: (form) => Boolean(form.date && form.bookingGroupIds && getId(form.exercise)),
  },
  [GDANSK_KIND_PASS_OPEN]: {
    fields: [GDANSK_DATE_INPUT, GDANSK_ENTRIES_QNT_INPUT, GDANSK_BASIN_KIND_INPUT, GDANSK_TIME_OF_DAY_INPUT],
    validate: (form) => Boolean(form.date && form.bookingGroupIds && form.colorIds && form.materialGroupIds),
  },
  [GDANSK_KIND_BEARER_PASS]: {
    fields: [GDANSK_DATE_INPUT, GDANSK_ENTRIES_QNT_INPUT],
    validate: (form) => Boolean(form.date && form.bookingGroupIds),
  },
  [GDANSK_KIND_SINGLE_TICKET]: {
    fields: [GDANSK_DATE_INPUT, GDANSK_LANE_SELECT_INPUT],
    validate: (form) => Boolean(form.date && getId(form.exercise)),
  },
  [GDANSK_KIND_SWIMMING_TRACK]: {
    fields: [GDANSK_DATE_INPUT, GDANSK_INSTRUCTOR_LANE_INPUT, GDANSK_INSTRUCTOR_CHECKBOX_INPUT],
    validate: (form) => Boolean(form.date && getId(form.exercise) && form.intructorRule),
  },
};

export default gdanskSaleFormConfigs;
